"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @function passportReducer
 * @param state
 * @param action
 * @returns passport state
 */
var passport_1 = require("../../actions/passport");
function passportReducer(state, action) {
    if (state === void 0) { state = passport_1.DefaultState; }
    switch (action.type) {
        case passport_1.BUILD_PASSPORT: {
            var newState = Object.assign({}, state);
            newState.countryOptionList = action.passport.countryOptionList;
            newState.passportNumber = action.passport.passportNumber;
            newState.passportCountry = action.passport.passportCountry;
            return newState;
        }
        case passport_1.CHANGE_PASSPORT: {
            var newState = Object.assign({}, state);
            newState.passportNumber = action.passportNumber;
            newState.passportCountry = action.passportCountry;
            return newState;
        }
        default:
            return state;
    }
}
exports.default = passportReducer;
